export const SET_WEBSITE_CONFIG = 'config/SET_WEBSITE_CONFIG'
export const SET_AGREE_TERMS = 'config/SET_AGREE_TERMS'
export const CLEAR_AGREE_TERMS = 'config/CLEAR_AGREE_TERMS'
export const RESET_STORE = 'config/RESET_STORE'


